
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Referral } from '@/api/model/referral'
import { allowedReferralStatusReasons } from '@/api/types'
import { ReferralStatus } from '@/api/types'
import { ReferralStatusReason } from '@/api/types'
import { ReferralType } from '@/api/types'

@Component
export default class ReopenTaskForm extends Vue {
    @Prop() readonly value!: Referral
    initialStatus: ReferralStatus = null
    initialStatusReason: ReferralStatusReason = null

    beforeMount() {
        this.initialStatus = this.value.status
        this.initialStatusReason = this.value.statusReason

        this.value.status = this.validStatuses.length ? this.validStatuses[0] : null
        this.value.statusReason = this.validStatusReasons.length ? this.validStatusReasons[0] : null
    }

    get assignableUsers(): User[] {
        if (this.$currentCompany === null) {
            return []
        }

        return this.$currentCompany.getAvailableUsers()
    }

    get validStatuses() {
        let statuses = []

        switch (this.value.type) {
            default:
                if (this.initialStatus === ReferralStatus.PROCESSED) {
                    statuses = [
                        ReferralStatus.NEW,
                        ReferralStatus.PENDING,
                        ReferralStatus.APPOINTMENT,
                        ReferralStatus.UNREACHABLE,
                    ]
                } else {
                    statuses = [
                        ReferralStatus.PENDING,
                        ReferralStatus.UNREACHABLE,
                    ]
                }
                break
        }

        return statuses
    }

    get validStatusOptions() {
        return this.validStatuses.map(status => {
            return {
                label: this.$t(`referral.status.${status}`),
                value: status,
            }
        })
    }

    get validStatusReasons() {
        const allowedStatusReasons = allowedReferralStatusReasons(
            this.value.type as ReferralType,
            this.value.status as ReferralStatus,
        )

        if (this.initialStatus === ReferralStatus.PROCESSED) {
            allowedStatusReasons.unshift(ReferralStatusReason.PROCESSED_REOPENED)
        } else {
            allowedStatusReasons.unshift(ReferralStatusReason.REOPENED)
        }

        return allowedStatusReasons
    }

    get validStatusReasonOptions() {
        return this.validStatusReasons.map(statusReason => {
            return {
                label: this.$t(`referral.statusReason.${statusReason}`),
                value: statusReason,
            }
        })
    }

    @Watch('validStatusReasons')
    resetStatusReason() {
        if (!this.validStatusReasons.includes(this.value.statusReason)) {
            this.value.statusReason = null
        }
    }
}
